import { render, staticRenderFns } from "./RecordAssist.vue?vue&type=template&id=2e4d3116"
import script from "./RecordAssist.vue?vue&type=script&lang=js"
export * from "./RecordAssist.vue?vue&type=script&lang=js"
import style0 from "./RecordAssist.vue?vue&type=style&index=0&id=2e4d3116&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports